import { supabase, TABLES } from '../supabase';
import { User } from '../../types';

// ============================================
// Users Service
// ============================================

export const usersApi = {
  /**
   * Get all users
   */
  async getAll(): Promise<User[]> {
    const { data, error } = await supabase
      .from(TABLES.USERS)
      .select('*');
    
    if (error) throw error;
    return data || [];
  },

  /**
   * Get a single user by ID
   */
  async getById(id: string): Promise<User | null> {
    const { data, error } = await supabase
      .from(TABLES.USERS)
      .select('*')
      .eq('id', id)
      .maybeSingle();
    
    if (error) throw error;
    return data;
  },

  /**
   * Get users by IDs
   */
  async getByIds(ids: string[]): Promise<User[]> {
    if (ids.length === 0) return [];
    
    const { data, error } = await supabase
      .from(TABLES.USERS)
      .select('*')
      .in('id', ids);
    
    if (error) throw error;
    return data || [];
  },

  /**
   * Create or update a user (upsert)
   */
  async upsert(user: User): Promise<void> {
    const { error } = await supabase
      .from(TABLES.USERS)
      .upsert(user);
    
    if (error) throw error;
  },

  /**
   * Update a user
   */
  async update(id: string, updates: Partial<User>): Promise<void> {
    const { error } = await supabase
      .from(TABLES.USERS)
      .update(updates)
      .eq('id', id);
    
    if (error) throw error;
  },

  /**
   * Delete a user
   */
  async delete(id: string): Promise<void> {
    const { error } = await supabase
      .from(TABLES.USERS)
      .delete()
      .eq('id', id);
    
    if (error) throw error;
  },

  /**
   * Search users by name or email
   */
  async search(query: string): Promise<User[]> {
    const { data, error } = await supabase
      .from(TABLES.USERS)
      .select('*')
      .or(`name.ilike.%${query}%,email.ilike.%${query}%`);
    
    if (error) throw error;
    return data || [];
  },
};

export default usersApi;
